import { useTranslation } from 'react-i18next';

import { cn } from '@nucleus-commerce/ui/lib/utils';

import type { GuideHeading } from '../content';

import { DocsRail } from './docs-shell-rail';

/** "On this page" in the right rail, from the headings the MDX pipeline exports. */
export function DocsToc({ headings }: { headings: GuideHeading[] }) {
  const { t } = useTranslation('docs');
  if (headings.length === 0) return null;
  return (
    <DocsRail label={t('rail.onThisPage')}>
      <ul className="flex flex-col gap-1.5 text-sm">
        {headings.map((heading) => (
          <li key={heading.id} className={cn(heading.depth === 3 && 'pl-3')}>
            <a
              href={`#${heading.id}`}
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              {heading.text}
            </a>
          </li>
        ))}
      </ul>
    </DocsRail>
  );
}
